import { render, staticRenderFns } from "./chat-user-list.html?vue&type=template&id=1687d11c&scoped=true&"
import script from "./chat-user-list.js?vue&type=script&lang=js&"
export * from "./chat-user-list.js?vue&type=script&lang=js&"
import style0 from "./chat-user-list.scss?vue&type=style&index=0&id=1687d11c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1687d11c",
  null
  
)

export default component.exports